import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Button,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
  Autocomplete,
  useTheme,
  Box,
  Divider,
  Tooltip,
  IconButton,
  Collapse,
  LinearProgress,
  Chip,
  Tabs,
  Tab,
  debounce,
} from "@mui/material";

import useProductList from "../../../hooks/useProductList"; // Assuming this is where the hook is defined
import useMaterialList from "../../../hooks/useMaterialList";
import CustomTableContainer from "../../../components/table/CustomTableContainer";

import { tokens } from "../../../theme/theme";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import usePlanBomCRUD from "../../../hooks/usePlanBomCRUD";
import CallAlertBar from "../../../Layout/Alertbar";
import Header from "../../../Layout/Header";
import useProductListBudgetPlanDetail from "../../../hooks/useBillOfMaterialPlanDetail";

//icons 
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';

import DownloadIcon from '@mui/icons-material/Download';


import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import useExportBillOfMaterialInExcel from "../../../hooks/useExportBillOfMaterialInExcel";
import useBillOfMaterialPlanGetDetail from "../../../hooks/useBillOfMaterialPlanGetMaterialDetails";
import useFetchBOMID from "../../../hooks/useFetchIDBasedonProduct";
import AddNewRequestIndent from "../../purchase/request-indent/AddRequestIndent";





// tab panel
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


const AddBillOfMaterialPlan = ({ handlecallback, editMaterialID, setEditMaterialID }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // display message
  const callMessage = (serverityval, msg, title) => {
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };

  const [isLoadProductDetail, setLoadProductDetail] = useState(false);
  const [bomID, setBOMID] = useState(0);
  const [isLoadEditPO, setLoadEditPO] = useState(false);
  const [viewRequestIndent, setViewRequestIndent] = useState(false);
  const [directData, setDirectData] = useState([]);

  const [callCalculation, setCallCalculation] = useState(false);
  const [demandQuantity, setDemandQuantity] = useState(0);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  const [rawMaterialRows, setRawMaterialRows] = useState([]); // Stores dynamic rows
  const [chemicalMaterialRows, setChemicalMaterialRows] = useState([]); // Stores dynamic rows
  const [fuelMaterialRows, setfuelMaterialRows] = useState([]);
  const [rawMaterial, setRawMaterial] = useState([]);
  const [chemicalMaterial, setChemicalMaterial] = useState([]);
  // const [budgetID, setBudgetID] = useState(0);
  const [selectionMode, setSelectionMode] = useState(0);
  const [addNewPlan, setAddNewPlan] = useState(false);


  const [plans, setPlans] = useState([]);
  const [newPlan, setNewPlan] = useState({ varietycode: "", budget_year: "", budget_month: "", production_quantity: 0, budget_bomCost: 1 });

  const { planningDetailList, setPlanningDetailList, loadProductWisePlanDetail, } = useProductListBudgetPlanDetail(editMaterialID);
  const { productList, selectedProduct, selectedProductID, setSelectedProduct, setSelectedProductID, loadProductByID, } = useProductList(0);
  const { materialList, setMaterialList, selectMaterial, selectMaterialID, loadMaterialListByID, } = useMaterialList();
  const { billOfMaterialDet, planmaterialList, loading, error } = useBillOfMaterialPlanGetDetail(bomID);
  const { selectedbomID, sloading, serror } = useFetchBOMID(selectedProductID, isLoadProductDetail, callMessage);

  const { exportExcel } = useExportBillOfMaterialInExcel();
  const [selectedButton, setSelectedButton] = useState(null);

  const [enableSaveBtn, setEnableSaveBtn] = useState(false);
  const [value, setValue] = React.useState(0);

  const { processIndent } = usePlanBomCRUD(callMessage);

  // display details
  const [displayMode, setDisplayMode] = useState(0);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedRequestID, setSelectedRequestID] = useState(0);
  const [selectedBudgetId, setSelectedBudgetId] = useState('');


  // tab change 

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPlan({ ...newPlan, [name]: value });

  };



  useEffect(() => { if (editMaterialID !== 0) { loadProductByID(editMaterialID); } }, [editMaterialID])


  useEffect(() => {
    if (planningDetailList?.length > 0) {
      setPlans(planningDetailList);
    }
    else {
      setPlans([]);
    }
  }, [planningDetailList])


  const addPlan = async () => {
    if (selectedProduct && newPlan.budget_year && newPlan.budget_month && newPlan.production_quantity > 0 && newPlan.budget_bomCost > 0) {

      setPlans([...plans, { ...newPlan, varietycode: selectedProduct.varietycode }]);
      setNewPlan({ product: "", budget_year: "", budget_month: "", production_quantity: 0, budget_bomCost: 1 });
      setSelectedProduct(null);

      // update to data base
      let user = localStorage.getItem('userID');
      let mode_id = 0;
      let id_budject_plan = 0;

      if (editMaterialID != 0) {
        mode_id = 1;  // Edit mode
      }

      if (selectionMode === 0) {
        id_budject_plan = editMaterialID !== 0 ? editMaterialID : 0;
      } else {
        id_budject_plan = 0;
      }

      // Validation before proceeding
      if (!selectedProductID) {
        alert("Please select a valid product!");
        return;
      }
      if (!newPlan.budget_year || !newPlan.budget_month) {
        alert("Please provide a valid budget year and month!");
        return;
      }
      if (!newPlan.production_quantity || isNaN(newPlan.production_quantity) || newPlan.production_quantity <= 0) {
        alert("Please enter a valid production quantity greater than 0!");
        return;
      }
      if (!user) {
        alert("User ID is missing. Please log in again!");
        return;
      }

      const requestBody = {
        p_companyid: localStorage.getItem('companyid'),
        p_plantid: 1,
        p_mode: mode_id,
        p_id_budget: id_budject_plan,
        p_productvariety_id: selectedProductID,
        p_budget_year: newPlan.budget_year,
        p_budget_month: newPlan.budget_month,
        p_createdby: user,
        p_production_quantity: newPlan.production_quantity,
      };

      // If validation is successful, call processIndent
      processIndent(0, id_budject_plan, requestBody);

      await loadProductWisePlanDetail(selectedProductID);
      setAddNewPlan(false);
      setEnableSaveBtn(false);
      setEnableSaveBtn(false);

    } else {
      alert("Please fill out all fields and ensure quantity and cost are greater than zero.");
    }
  };

  const aggregateCostsByQuarter = (plans) => {
    const quarterMap = {
      January: "Q1",
      February: "Q1",
      March: "Q1",
      April: "Q2",
      May: "Q2",
      June: "Q2",
      July: "Q3",
      August: "Q3",
      September: "Q3",
      October: "Q4",
      November: "Q4",
      December: "Q4",
    };

    const aggregatedData = {};

    plans.forEach((plan) => {
      const { varietycode, budget_year, budget_month, budget_bomCost, production_quantity } = plan;
      const quarter = quarterMap[budget_month];
      const key = `${varietycode}-${budget_year}`;

      if (!aggregatedData[key]) {
        aggregatedData[key] = { varietycode, budget_year, Q1: 0, Q2: 0, Q3: 0, Q4: 0, total: 0 };
      }

      // Ensure numeric addition instead of string concatenation
      aggregatedData[key][quarter] += Number(production_quantity);
      aggregatedData[key].total += Number(production_quantity);
    });

    return Object.values(aggregatedData);
  };


  const years = Array.from({ length: 11 }, (_, i) => 2020 + i); // Generate years from 2020 to 2030
  const aggregatedPlans = aggregateCostsByQuarter(plans);

  // load material bom details
  useEffect(() => {
    const fetchData = async () => {
      if (selectedProductID != null && selectedProductID != 0) {
        if (selectedbomID) {
          setBOMID(selectedbomID);
        }
      }
    };
    fetchData();
  }, [selectedbomID]);



  useEffect(() => {
    const fetchData = async () => {
      if (!isLoadEditPO && bomID != 0 && billOfMaterialDet) {
        try {

          if (planmaterialList && planmaterialList.length > 0) {
            setMaterialList(planmaterialList);
          }

          if (billOfMaterialDet) {

            loadProductByID(billOfMaterialDet.productvariety_id);

            // comman data format
            const parseData = (data) => typeof data === 'string' ? JSON.parse(data) : data;

            //comman function for calculation
            const mapRows = (dataList) =>
              dataList.map((item, index) => {
                // Sum totalTon to get total_qty (if totalTon exists in your productData array)                
                const total_qty = item.layers.reduce((sum, layer) => sum + parseFloat(layer.totalTon || 0), 0);  // Sum totalTon from all layers
                let purchase = item.available_quantity < total_qty ? total_qty - item.available_quantity : 0;

                return {
                  ...item,
                  id: index + 1, // Use index for ID
                  material: planmaterialList.find((p) => p.id_material === item.id_material) || "",
                  id_material: item.id_material,
                  total_qty: total_qty.toFixed(2), // Ensure 2-decimal formatting for total_qty
                  purchase: purchase,
                };
              });

            // Handle Raw Material Rows
            const productData = parseData(billOfMaterialDet.bomitem_list);
            setRawMaterialRows(Array.isArray(productData) ? mapRows(productData) : []);

            // handle chemical rows
            const chemicalData = parseData(billOfMaterialDet.bom_chemical_list);
            setChemicalMaterialRows(Array.isArray(chemicalData) ? mapRows(chemicalData) : []);

            // handle fuel rows
            const fuelData = parseData(billOfMaterialDet.bom_fuel_list);
            setfuelMaterialRows(Array.isArray(fuelData) ? mapRows(fuelData) : []);

            await loadProductByID(billOfMaterialDet.productvariety_id);

          }
        } catch (error) {
          callMessage('error', error.message, 'Error');
        }
      }
    };

    fetchData();
  }, [isLoadEditPO, bomID, billOfMaterialDet, planmaterialList,]);


  // i want update  raw material and chemical value based on demand qty

  const updateRawMaterialAndChemicalBasedOnDemand = async (demandQuantity) => {

    const updateRowsBasedOnDemand = (rows, demandQuantity, isChemical = false) => {
      return rows.map(row => ({
        ...row,
        layers: row.layers.map(layer => ({
          ...layer,
          totalTon: isChemical
            ? layer.kgPerTon
              ? (parseFloat(layer.kgPerTon) * demandQuantity).toFixed(3)
              : ""
            : layer.tonsPerTon
              ? (parseFloat(layer.tonsPerTon) * demandQuantity).toFixed(3)
              : ""
        })),
      }));
    };

    const newRawMaterialRows = updateRowsBasedOnDemand(rawMaterialRows, demandQuantity);
    const newChemicalRows = updateRowsBasedOnDemand(chemicalMaterialRows, demandQuantity, true);
    const newFuelRows = updateRowsBasedOnDemand(fuelMaterialRows, demandQuantity, true);

    setRawMaterialRows(newRawMaterialRows);
    setChemicalMaterialRows(newChemicalRows);
    setfuelMaterialRows(newFuelRows);


  }

  useEffect(() => {
    if (callCalculation) {
      const fatchdata = async () => {
        await updateRawMaterialAndChemicalBasedOnDemand(demandQuantity);
        setCallCalculation(false);
      }
      fatchdata();
    }
  });


  // Helper function to calculate summary for layers
  const calculateLayerSummary = (rows, fields) => {
    return rows.reduce((acc, row) => {
      row.layers.forEach((layer, i) => {
        fields.forEach(field => {
          acc[field][i] += parseFloat(layer[field]) || 0;
        });
      });
      return acc;
    }, Object.fromEntries(fields.map(field => [field, [0, 0, 0, 0]])));
  };

  // Helper function to update rows with recalculated total_qty
  const updateRowsWithTotalQty = (rows, setRows) => {
    const mappedRows = rows.map(item => {
      const total_qty = item.layers.reduce((sum, layer) => sum + parseFloat(layer.totalTon || 0), 0);
      return parseFloat(item.total_qty || 0) !== total_qty
        ? { ...item, total_qty: total_qty.toFixed(2) }
        : item;
    });

    // Update state only if data has changed
    if (JSON.stringify(mappedRows) !== JSON.stringify(rows)) {
      setRows(mappedRows);
    }
  };

  // Calculate summaries
  const summary = calculateLayerSummary(rawMaterialRows, ['furnish', 'tonsPerTon', 'totalTon']);
  const chemicalSummary = calculateLayerSummary(chemicalMaterialRows, ['dosage', 'kgPerTon', 'totalTon']);
  const fuelSummary = calculateLayerSummary(fuelMaterialRows, ['dosage', 'kgPerTon', 'totalTon']);


  // Update total_qty for rawMaterialRows
  useEffect(() => {
    if (Array.isArray(rawMaterialRows) && rawMaterialRows.length > 0) {
      updateRowsWithTotalQty(rawMaterialRows, setRawMaterialRows);
    }
  }, [rawMaterialRows]);

  // Update total_qty for chemicalMaterialRows
  useEffect(() => {
    if (Array.isArray(chemicalMaterialRows) && chemicalMaterialRows.length > 0) {
      updateRowsWithTotalQty(chemicalMaterialRows, setChemicalMaterialRows);
    }
  }, [chemicalMaterialRows]);

  useEffect(() => {
    if (Array.isArray(fuelMaterialRows) && fuelMaterialRows.length > 0) {
      updateRowsWithTotalQty(fuelMaterialRows, setfuelMaterialRows);
    }
  }, [fuelMaterialRows]);



  // update material list 
  useEffect(() => {

    if (materialList.length > 0) {
      // Get raw material list
      const raw = materialList.filter((r) => r.category_desc === 'RAW MATERIAL');
      setRawMaterial(raw);

      // Get chemical material list
      const chemicalraw = materialList.filter((r) => r.category_desc === 'CHEMICAL AND DYES');
      setChemicalMaterial(chemicalraw);

      const fuelraw = materialList.filter((r) => r.category_desc === 'FUEL');
      setChemicalMaterial(fuelraw);
    }

  }, [materialList]);

  // hand sub menu selection button
  const handleSelectButton = (buttonname) => {
    if (buttonname === 'Addnew') {
      setSelectedButton('Addnew');
      setDisplayMode(0);
      setSelectedYear('');
      setSelectedMonth('');
      setAddNewPlan(true);
      setEnableSaveBtn(true);
    }
    else if (buttonname === 'AddnewPlan') {
      setSelectedButton('AddnewPlan');
      addPlan();
    }
    else if (buttonname == 'PurchaseRequest') {
      handleRequestIndent();
    }
  }

  const [expandedYear, setExpandedYear] = useState(null); // Track expanded year

  const handleToggleExpand = (year) => {
    setExpandedYear(expandedYear === year ? null : year); // Toggle expand/collapse
  };

  const groupByYear = (plans) => {
    return plans.reduce((acc, plan) => {
      if (!acc[plan.budget_year]) {
        acc[plan.budget_year] = [];
      }
      acc[plan.budget_year].push(plan);
      return acc;
    }, {});
  };

  const groupedPlans = groupByYear(plans);


  //select plan quantity value if already available then

  const getProductionQuantity = async (year, month) => {
    if (plans?.length > 0) {
      // Filter plans based on matching year and month
      const planqty = plans.filter((plan) => plan.budget_year === year && plan.budget_month === month);

      if (planqty.length > 0) {
        // If a matching plan is found, update the state and editMaterialID
        setNewPlan({ ...newPlan, production_quantity: planqty[0].production_quantity, budget_month: planqty[0].budget_month });
        setEditMaterialID(planqty[0].id_budget);
        setEnableSaveBtn(true);
      } else {
        // Handle case where no matching plan is found
        console.warn(`No plan found for year: ${year} and month: ${month}`);
        setNewPlan({ ...newPlan, production_quantity: 0, budget_month: month });
        setEditMaterialID(0);
        setEnableSaveBtn(true);
      }
    } else {
      console.warn("No plans available to filter.");
    }
  };

  //  get total of product demand
  const handleSumOfBomQty = (year) => {
    const totalPlanQty = plans
      .filter((plan) => plan.budget_year == year)
      .reduce((sum, plan) => sum + plan.production_quantity, 0); // Using reduce to sum the production_quantity

    if (totalPlanQty > 0) {
      setDemandQuantity(totalPlanQty);
      setCallCalculation(true);
    }
  };


  // export to excel data 
  const exportToExcel = () => {
    exportExcel(rawMaterialRows, chemicalMaterialRows,fuelMaterialRows);
  }
  const [selectedMode, setSelectedMode] = useState(53);

  // call request indent
  const handleRequestIndent = async () => {
    const allRows = [...rawMaterialRows, ...chemicalMaterialRows, ...fuelMaterialRows]; // Combine both arrays

    if (Array.isArray(allRows)) {
      const mappedRows = allRows.map((item, index) => ({
        id: index + 1,
        material: planmaterialList.find(p => p.id_material === item.id_material) || '',
        id_material: item.id_material,
        material_name: planmaterialList.find(p => p.id_material === item.id_material)?.material_name || '',
        uom: planmaterialList.find(p => p.id_material === item.id_material)?.unit_of_measurement || '',
        uomId: planmaterialList.find(p => p.id_material === item.id_material)?.id_uom || '',
        quantity_requested: item.total_qty,
        scheduled_issue_date: new Date().toISOString().split('T')[0],
        quantity_approved: 0,
        purpose: 'For Production BOM'
      }));

      setDirectData(mappedRows);
      setViewRequestIndent(true);
    }
  };


  const callBack = () => { setViewRequestIndent(false); };


  useEffect(() => {

    if (selectedRequestID !== undefined && selectedRequestID !== 0) {
      setSelectedMode(0);
    } else {
      setSelectedMode(53);
      setSelectedRequestID(0);
    }

  }, [selectedRequestID]);


  useEffect(() => {
    if (newPlan.budget_year && newPlan.budget_month) {
      getProductionQuantity(parseInt(newPlan.budget_year), newPlan.budget_month);
    }
  }, [newPlan.budget_year, newPlan.budget_month]);


  return (

    <Box >

      {viewRequestIndent ? (<>
        <AddNewRequestIndent handlecallback={callBack} editRequestIndentID={selectedRequestID} setEditRequestIndentID={selectedRequestID} selectedMode={selectedMode} setSelectedMode={setSelectedMode} requestData={directData} budgetID={selectedBudgetId} />
      </>) : (<>

        {selectionMode === 0 ? (<>
          <Header title={editMaterialID == 0 ? 'Add New Paper Production Plan' : 'Edit Paper Production Plan'} subtitle="" callback={handlecallback} />
        </>) : (<>
          <Header title={editMaterialID == 0 ? 'Approve Request Indent' : 'Edit Approve Request Indent'} subtitle="" callback={handlecallback} />
        </>)}
        <Divider />
        <Grid item xs={12} xl={12} md={12} sm={12}  >
          <Grid container display="flex-start" padding={0}>
            <Grid item md={0} ml="1px" mr="1px">
              <Tooltip title="Add New">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <IconButton onClick={(e) => { handleSelectButton('Addnew') }} >
                    <AddCircleOutlineIcon style={{ fontSize: "18px", color: selectedButton === 'Addnew' ? "yellow" : "#009688" }} />
                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Add New Plan</Typography>
                  </IconButton>
                </div>
              </Tooltip>
            </Grid>
            {enableSaveBtn && (
              <>
                <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
                <Grid item md={0} ml="1px" mr="1px">
                  <Tooltip title="Save BOM">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <IconButton onClick={(e) => { handleSelectButton('AddnewPlan') }} >
                        <SaveAltIcon style={{ fontSize: "18px", color: selectedButton === 'AddnewPlan' ? "yellow" : "#009688" }} />
                        <Typography variant="h6" sx={{ marginLeft: "5px" }}>Save BOM Plan</Typography>
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
              </>
            )}
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {/* Add Button */}
            <Grid item md={0} ml="1px" mr="1px">
              <Tooltip title="Download bom details to excel">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <IconButton onClick={() => { exportToExcel() }} >
                    <DownloadIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Download Excel</Typography>
                  </IconButton>
                </div>
              </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            {(displayMode !== 0 && displayMode !== 1) && (<>
              <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Create Purchase Indent">
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IconButton onClick={(e) => { handleSelectButton('PurchaseRequest') }} >
                      <AddIcon style={{ fontSize: "18px", color: selectedButton === 'PurchaseRequest' ? "yellow" : "#009688" }} />
                      <Typography variant="h6" sx={{ marginLeft: "5px" }}>Create Purchase Request</Typography>
                    </IconButton>
                  </div>
                </Tooltip>
              </Grid>
              <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            </>)}
          </Grid>
          <Divider />
        </Grid>

        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

        <ResponsiveBox
          customMaxHeight={{
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '70vh', // Medium devices (small laptops)
            lg: '75vh', // Large devices (desktops)
            xl: '83vh', // Extra large devices (large desktops)
          }}>

          {addNewPlan && (
            <Card sx={{ marginTop: "10px", marginBottom: "10px" }}>
              <CardContent>

                <form>
                  <Grid container spacing={1}>  {/* Reduced overall grid spacing */}

                    {/* Product Selection */}
                    <Grid item xs={12}>
                      <Grid container alignItems="center" spacing={1}>  {/* Reduced spacing here */}
                        <Grid item xs={12} sm={3} md={2}>
                          <Typography required variant="h6" fontSize={14} textAlign="left">
                            Product Code
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={9} md={4}>
                          <Autocomplete
                            size="small"
                            fullWidth
                            options={productList}
                            value={selectedProduct}
                            onChange={(event, newValue) => {
                              setSelectedProduct(newValue);
                              setSelectedProductID(newValue ? newValue.id : "");
                              loadProductByID(null, newValue ? newValue.id : "");
                              loadProductWisePlanDetail(newValue ? newValue.id : "");
                            }}
                            getOptionLabel={(option) => option.varietycode || ""}
                            renderInput={(params) => (
                              <TextField {...params} label="Select Product" placeholder="Choose a product" required size="small" />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Year / Month Selection */}
                    <Grid item xs={12}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} sm={3} md={2}>
                          <Typography variant="h6" fontSize={14}>
                            Year / Month
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={4} md={2}>

                          <TextField
                            label="Select Month"
                            type="month"
                            value={
                              newPlan.budget_year && newPlan.budget_month
                                ? (() => {
                                  const monthIndex = new Date(`${newPlan.budget_month} 1, ${newPlan.budget_year}`).getMonth();
                                  const monthFormatted = String(monthIndex + 1).padStart(2, "0");
                                  return `${newPlan.budget_year}-${monthFormatted}`;
                                })()
                                : ""
                            }
                            onChange={(e) => {
                              const [year, month] = e.target.value.split("-");

                              const monthName = new Date(`${year}-${month}-01`).toLocaleString("default", {
                                month: "long"
                              });

                              setNewPlan((prev) => ({
                                ...prev,
                                budget_year: year,
                                budget_month: monthName
                              }));

                              // getProductionQuantity(parseInt(year), monthName);
                            }}
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                          />

                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Production Plan Quantity */}
                    <Grid item xs={12}>
                      <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={12} sm={3} md={2}>
                          <Typography required variant="h6" fontSize={14} textAlign="left">
                            Production Plan Qty
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={9} md={4}>
                          <TextField
                            label="Plan Quantity"
                            type="number"
                            name="production_quantity"
                            value={newPlan.production_quantity}
                            onChange={(e) => {
                              handleInputChange(e);
                              setDemandQuantity(e.target.value);
                              setCallCalculation(true);
                            }}
                            placeholder="Enter quantity"
                            fullWidth
                            size="small"
                            required
                            inputProps={{ min: 1 }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          )}

          <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h4" sx={{ fontWeight: "bold", color: "#498" }} gutterBottom>
                Production Plans with Cost Breakdown
              </Typography>

              <CustomTableContainer colors={colors}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Year</TableCell>
                        {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((month) => (
                          <TableCell key={month} sx={{ fontWeight: "bold" }}>{month}</TableCell>
                        ))}
                        <TableCell sx={{ fontWeight: "bold" }}>Total Plan Quantity</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {Object.entries(groupedPlans).map(([year, yearPlans]) => {

                        const monthMap = {
                          Jan: [], Feb: [], Mar: [], Apr: [], May: [], Jun: [],
                          Jul: [], Aug: [], Sep: [], Oct: [], Nov: [], Dec: [],
                        };

                        yearPlans.forEach(plan => {
                          const month = plan.budget_month.slice(0, 3); // e.g., "Jan"
                          if (monthMap[month] !== undefined) {
                            monthMap[month].push({
                              production_quantity: plan.production_quantity,
                              budget_year: plan.budget_year,
                              budget_month: plan.budget_month,
                              id_request: plan.id_request,
                              id_budget: plan.id_budget
                            });
                          }
                        });


                        return (
                          <React.Fragment key={year}>
                            {/* Year + Monthly Quantity Row */}

                            <TableRow>
                              <TableCell>
                                <Typography
                                  key={year}
                                  variant="body2"
                                  color="secondary"
                                  sx={{ cursor: "pointer", textDecoration: "underline", display: "block" }}
                                  onClick={() => { handleSumOfBomQty(year); setDisplayMode(1); setSelectedYear(year); setSelectedMonth(''); setSelectedRequestID(0); setSelectedBudgetId(0); }}
                                >
                                  {year}
                                </Typography>
                              </TableCell>
                              {Object.entries(monthMap).map(([month, plans]) => (
                                <TableCell key={month}>
                                  {plans.length > 0 ? (
                                    plans.map((plan, idx) => (
                                      <Typography
                                        key={idx}
                                        variant="body2"
                                        color="secondary"
                                        sx={{ cursor: "pointer", textDecoration: "underline", display: "block" }}
                                        onClick={() => {
                                          setDemandQuantity(plan.production_quantity);
                                          setCallCalculation(true);
                                          setDisplayMode(2);
                                          setSelectedYear(plan.budget_year);
                                          setSelectedMonth(plan.budget_month);
                                          setSelectedRequestID(plan.id_request);
                                          setSelectedBudgetId(plan.id_budget);
                                        }}
                                      >
                                        {plan.production_quantity}
                                      </Typography>
                                    ))
                                  ) : (
                                    0
                                  )}
                                </TableCell>
                              ))}
                              <TableCell>
                                {Object.values(monthMap).reduce((sum, plans) =>
                                  sum + plans.reduce((s, p) => s + p.production_quantity, 0), 0)}
                              </TableCell>
                            </TableRow>


                            {/* Quarter-wise View Toggle Row */}
                            <TableRow>
                              <TableCell colSpan={13}>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                  <Typography>
                                    View Quarter wise plan quantity .{year}
                                  </Typography>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => handleToggleExpand(year)}
                                  >
                                    Expandable Product Cost Details
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>

                            {/* Expandable Quarter-wise Details */}
                            <TableRow>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
                                <Collapse in={expandedYear === year} timeout="auto" unmountOnExit>
                                  <Box sx={{ padding: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
                                      Product Cost Year & Quarter Wise for {year}
                                    </Typography>
                                    <Divider sx={{ marginBottom: 2 }} />

                                    <TableContainer component={Paper}>
                                      <Table>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell sx={{ fontWeight: "bold" }}>Q1</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }}>Q2</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }}>Q3</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }}>Q4</TableCell>
                                            <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {aggregatedPlans
                                            .filter(plan => plan.budget_year === parseInt(year))
                                            .map((plan, idx) => (
                                              <TableRow key={idx}>
                                                {[plan.Q1, plan.Q2, plan.Q3, plan.Q4].map((q, i) => (
                                                  <TableCell key={i}>
                                                    <LinearProgress
                                                      variant="determinate"
                                                      value={(q / plan.total) * 100}
                                                      sx={{
                                                        height: 8,
                                                        borderRadius: 5,
                                                        backgroundColor: "white",
                                                        "& .MuiLinearProgress-bar": {
                                                          background: "linear-gradient(to right, #43a047, #66bb6a)",
                                                        },
                                                      }}
                                                    />
                                                    <Typography variant="caption">{q}</Typography>
                                                  </TableCell>
                                                ))}
                                                <TableCell>
                                                  <Chip size="small" label={`${plan.total}`} color="success" />
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CustomTableContainer>
            </CardContent>
          </Card>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Grid container spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
              {/* padding="10px 0px 0px 20px"  */}
              <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                <Box mt={1}  >

                  {displayMode !== 0 ? (<>
                    <Box sx={{ padding: "10px", backgroundColor: colors.primary[400], borderRadius: "10px" }}>

                      {displayMode === 1 ? (
                        <>
                          <Typography>{selectedYear} Year BOM Plan
                            <Chip size="small" sx={{ marginLeft: '10px' }} label={`Planned Quantity : ` + `${demandQuantity}`} color="success" />
                          </Typography>
                        </>
                      ) : (
                        <Typography>{selectedYear}, {selectedMonth} BOM Plan
                          <Chip size="small" sx={{ marginLeft: '10px' }} label={`Planned Quantity : ` + `${demandQuantity}`} color="success" />
                        </Typography>
                      )}


                    </Box>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant="contained"
                        aria-label="full width tabs example"
                      >
                        <Tab sx={{ textTransform: "none" }} label="Raw Materials" {...a11yProps(0)} />
                        <Tab sx={{ textTransform: "none" }} label="Chemicals & Dyes" {...a11yProps(1)} />
                        <Tab sx={{ textTransform: "none" }} label="Fuels" {...a11yProps(2)} />
                      </Tabs>
                    </Box>



                    <SwipeableViews
                      axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                      index={value}
                      onChangeIndex={handleChangeIndex}
                    >
                      <TabPanel value={value} index={0} dir={theme.direction}>
                        <Box>
                          {rawMaterialRows?.length > 0 ? (<>
                            <Card >

                              <CardContent>


                                <CustomTableContainer colors={colors}>
                                  <TableContainer  >
                                    {/* component={Paper} */}
                                    <Table aria-label="BOM Table">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                          <TableCell rowSpan={2} align="center"><strong>Raw Material</strong></TableCell>

                                          <TableCell rowSpan={2} align="center">
                                            <strong>Yield</strong>
                                            <br />
                                            {/* A = (100% - B - C) */}
                                          </TableCell>

                                          {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                            <TableCell key={layer} colSpan={3} align="center" >
                                              <strong>{layer}</strong>
                                            </TableCell>
                                          ))}
                                          <TableCell rowSpan={2} align="center"><strong>Material Req.Qty</strong></TableCell>
                                          <TableCell rowSpan={2} align="center"><strong>Available Qty</strong></TableCell>
                                        </TableRow>

                                        <TableRow>
                                          {/* Columns for each layer */}
                                          {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                            <TableCell key={"top-" + label} align="center" >{label}</TableCell>
                                          ))}
                                          {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                            <TableCell key={"under-" + label} align="center" >{label}</TableCell>
                                          ))}
                                          {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                            <TableCell key={"filler-" + label} align="center" >{label}</TableCell>
                                          ))}
                                          {["Furnish", "tons/ton", "Total Tons"].map((label) => (
                                            <TableCell key={"back-" + label} align="center" >{label}</TableCell>
                                          ))}


                                        </TableRow>




                                      </TableHead>
                                      <TableBody>
                                        {/* Data rows can be added here */}
                                        {rawMaterialRows.map((row, index) => (
                                          <TableRow key={row.id}>
                                            <TableCell align="center">{row.id}</TableCell>
                                            <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }} >

                                              <TextField
                                                value={`${row.material?.material_code || ''} - ${row.material?.material_name || ''}`}
                                                placeholder="Select Material"
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'left',
                                                  },
                                                }}
                                                inputProps={{ readOnly: true }}  // Making the TextField read-only
                                              />

                                            </TableCell>


                                            {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                            {["yield"].map((field) => (
                                              <TableCell key={field}>
                                                <TextField
                                                  sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                      padding: '4px',
                                                      textAlign: 'center',
                                                    },
                                                  }}

                                                  type="number"
                                                  value={row[field]}
                                                  // onChange={(e) => updateRow(index, field, e.target.value)}
                                                  variant="outlined"
                                                  size="small"
                                                />
                                              </TableCell>
                                            ))}


                                            {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                            {row.layers.flatMap((layer, layerIndex) => [
                                              <TableCell key={`furnish-${index}-${layerIndex}`} >
                                                <TextField
                                                  sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                      padding: '4px',
                                                      textAlign: 'center',
                                                    },
                                                  }}

                                                  type="number"
                                                  value={layer.furnish}

                                                  variant="outlined"
                                                  size="small"
                                                />
                                              </TableCell>,
                                              <TableCell key={`tonsPerTon-${index}-${layerIndex}`} >
                                                <TextField
                                                  sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                      padding: '4px',
                                                      textAlign: 'center',
                                                    },
                                                  }}
                                                  type="number"
                                                  value={layer.tonsPerTon}

                                                  variant="outlined"
                                                  size="small"
                                                />
                                              </TableCell>,
                                              <TableCell key={`totalTon-${index}-${layerIndex}`} >
                                                <TextField
                                                  sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                      border: 'none',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                      padding: '4px',
                                                      textAlign: 'center',
                                                    },
                                                  }}
                                                  type="number"
                                                  value={layer.totalTon}

                                                  variant="outlined"
                                                  size="small"
                                                />
                                              </TableCell>

                                            ])}

                                            <TableCell align="center">{row.total_qty}</TableCell>
                                            <TableCell align="center">{row.available_quantity}</TableCell>

                                          </TableRow>
                                        ))}
                                        {/* Summary Row */}
                                        <TableRow>
                                          <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                          {summary.furnish.map((total, layerIndex) => (
                                            <React.Fragment key={layerIndex}>
                                              <TableCell align="center" >
                                                <strong>{total.toFixed(2)}</strong>
                                              </TableCell>
                                              <TableCell align="center" >
                                                <strong>{summary.tonsPerTon[layerIndex].toFixed(2)}</strong>
                                              </TableCell>
                                              <TableCell align="center" >
                                                <strong>{summary.totalTon[layerIndex].toFixed(2)}</strong>
                                              </TableCell>
                                            </React.Fragment>
                                          ))}
                                        </TableRow>

                                        {/* //available_quantity */}


                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </CustomTableContainer>

                              </CardContent>
                            </Card>
                          </>) : (null)}
                        </Box>
                      </TabPanel>

                      <TabPanel value={value} index={1} dir={theme.direction}>
                        {chemicalMaterialRows?.length > 0 ? (<>
                          <Card >

                            <CardContent>


                              <CustomTableContainer colors={colors}>
                                <TableContainer  >
                                  {/* component={Paper} */}
                                  <Table aria-label="BOM Table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                        <TableCell rowSpan={2} align="center" ><strong>Chemicals</strong></TableCell>

                                        <TableCell rowSpan={2} align="center">
                                          <strong>Yield</strong>
                                          <br />
                                          {/* A = (100% - B - C) */}
                                        </TableCell>

                                        {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                          <TableCell key={layer} colSpan={3} align="center">
                                            <strong>{layer}</strong>
                                          </TableCell>
                                        ))}
                                        <TableCell rowSpan={2} align="center"><strong>Material Req.Qty</strong></TableCell>
                                        <TableCell rowSpan={2} align="center"><strong>Available Qty</strong></TableCell>
                                      </TableRow>

                                      <TableRow>
                                        {/* Columns for each layer */}
                                        {["Dosage", "Kg/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"top-" + label} align="center" >{label}</TableCell>
                                        ))}
                                        {["Dosage", "Kg/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"under-" + label} align="center" >{label}</TableCell>
                                        ))}
                                        {["Dosage", "Kg/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"filler-" + label} align="center" >{label}</TableCell>
                                        ))}
                                        {["Dosage", "tons/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"back-" + label} align="center" >{label}</TableCell>
                                        ))}
                                      </TableRow>

                                    </TableHead>
                                    <TableBody>
                                      {/* Data rows can be added here */}
                                      {chemicalMaterialRows.map((row, index) => (
                                        <TableRow key={row.id}>
                                          <TableCell align="center">{row.id}</TableCell>
                                          <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }}>

                                            <TextField
                                              value={`${row.material?.material_code || ''} - ${row.material?.material_name || ''}`}
                                              placeholder="Select Material"
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                  border: 'none',
                                                },
                                                '& .MuiInputBase-input': {
                                                  padding: '4px',
                                                  textAlign: 'left',
                                                },
                                              }}
                                              inputProps={{ readOnly: true }}  // Making the TextField read-only
                                            />
                                          </TableCell>


                                          {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                          {["yield"].map((field) => (
                                            <TableCell key={field}>
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}

                                                type="number"
                                                value={row[field]}

                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>
                                          ))}


                                          {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                          {row.layers.flatMap((layer, layerIndex) => [
                                            <TableCell key={`dosage-${index}-${layerIndex}`} >
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}

                                                type="number"
                                                value={layer.dosage}
                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>,
                                            <TableCell key={`kgPerTon-${index}-${layerIndex}`} >
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}
                                                type="number"
                                                value={layer.kgPerTon}

                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>,
                                            <TableCell key={`totalTon-${index}-${layerIndex}`} >
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}
                                                type="number"
                                                value={layer.totalTon}
                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>
                                          ])}
                                          <TableCell align="center">{row.total_qty}</TableCell>
                                          <TableCell align="center">{row.available_quantity}</TableCell>
                                        </TableRow>
                                      ))}
                                      {/* Summary Row */}
                                      <TableRow>
                                        <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                        {chemicalSummary.dosage.map((total, layerIndex) => (
                                          <React.Fragment key={layerIndex}>
                                            <TableCell align="center" >
                                              <strong>{total.toFixed(2)}</strong>
                                            </TableCell>
                                            <TableCell align="center" >
                                              <strong>{chemicalSummary.kgPerTon[layerIndex].toFixed(2)}</strong>
                                            </TableCell>
                                            <TableCell align="center" >
                                              <strong>{chemicalSummary.totalTon[layerIndex].toFixed(2)}</strong>
                                            </TableCell>
                                          </React.Fragment>
                                        ))}
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                  {/* <Button onClick={addChemicalRow} variant="contained" color="secondary" style={{ margin: "10px" }}>
                                        Add Chemical
                                    </Button> */}
                                </TableContainer>
                              </CustomTableContainer>
                            </CardContent>
                          </Card>
                        </>) : (null)}
                      </TabPanel>

                      <TabPanel value={value} index={2} dir={theme.direction}>
                        {fuelMaterialRows?.length > 0 ? (<>
                          <Card >

                            <CardContent>


                              <CustomTableContainer colors={colors}>
                                <TableContainer  >
                                  {/* component={Paper} */}
                                  <Table aria-label="BOM Table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell rowSpan={2} align="center"><strong>S.No</strong></TableCell>
                                        <TableCell rowSpan={2} align="center" ><strong>Fuels</strong></TableCell>

                                        <TableCell rowSpan={2} align="center">
                                          <strong>Yield</strong>
                                          <br />
                                          {/* A = (100% - B - C) */}
                                        </TableCell>

                                        {["TOP Layer", "Under Top Layer", "Filler Layer", "Back Layer"].map((layer, layerIndex) => (
                                          <TableCell key={layer} colSpan={3} align="center">
                                            <strong>{layer}</strong>
                                          </TableCell>
                                        ))}
                                        <TableCell rowSpan={2} align="center"><strong>Material Req.Qty</strong></TableCell>
                                        <TableCell rowSpan={2} align="center"><strong>Available Qty</strong></TableCell>
                                      </TableRow>

                                      <TableRow>
                                        {/* Columns for each layer */}
                                        {["Dosage", "Kg/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"top-" + label} align="center" >{label}</TableCell>
                                        ))}
                                        {["Dosage", "Kg/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"under-" + label} align="center" >{label}</TableCell>
                                        ))}
                                        {["Dosage", "Kg/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"filler-" + label} align="center" >{label}</TableCell>
                                        ))}
                                        {["Dosage", "tons/ton", "Total Tons"].map((label) => (
                                          <TableCell key={"back-" + label} align="center" >{label}</TableCell>
                                        ))}
                                      </TableRow>

                                    </TableHead>
                                    <TableBody>
                                      {/* Data rows can be added here */}
                                      {fuelMaterialRows.map((row, index) => (
                                        <TableRow key={row.id}>
                                          <TableCell align="center">{row.id}</TableCell>
                                          <TableCell style={{ minWidth: "250px", whiteSpace: "nowrap" }}>

                                            <TextField
                                              value={`${row.material?.material_code || ''} - ${row.material?.material_name || ''}`}
                                              placeholder="Select Material"
                                              variant="outlined"
                                              fullWidth
                                              size="small"
                                              sx={{
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                  border: 'none',
                                                },
                                                '& .MuiInputBase-input': {
                                                  padding: '4px',
                                                  textAlign: 'left',
                                                },
                                              }}
                                              inputProps={{ readOnly: true }}  // Making the TextField read-only
                                            />
                                          </TableCell>


                                          {/* Input Fields for Cost, Yield, Moisture Loss, Process Loss */}
                                          {["yield"].map((field) => (
                                            <TableCell key={field}>
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}

                                                type="number"
                                                value={row[field]}

                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>
                                          ))}


                                          {/* Layer Inputs with Background Colors (Only "Furnish" and "tonsPerTon") */}
                                          {row.layers.flatMap((layer, layerIndex) => [
                                            <TableCell key={`dosage-${index}-${layerIndex}`} >
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}

                                                type="number"
                                                value={layer.dosage}
                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>,
                                            <TableCell key={`kgPerTon-${index}-${layerIndex}`} >
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}
                                                type="number"
                                                value={layer.kgPerTon}

                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>,
                                            <TableCell key={`totalTon-${index}-${layerIndex}`} >
                                              <TextField
                                                sx={{
                                                  '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                  },
                                                  '& .MuiInputBase-input': {
                                                    padding: '4px',
                                                    textAlign: 'center',
                                                  },
                                                }}
                                                type="number"
                                                value={layer.totalTon}
                                                variant="outlined"
                                                size="small"
                                              />
                                            </TableCell>
                                          ])}
                                          <TableCell align="center">{row.total_qty}</TableCell>
                                          <TableCell align="center">{row.available_quantity}</TableCell>
                                        </TableRow>
                                      ))}
                                      {/* Summary Row */}
                                      <TableRow>
                                        <TableCell colSpan={3} align="right"><strong>Summary (Total)</strong></TableCell>
                                        {fuelSummary.dosage.map((total, layerIndex) => (
                                          <React.Fragment key={layerIndex}>
                                            <TableCell align="center" >
                                              <strong>{total.toFixed(2)}</strong>
                                            </TableCell>
                                            <TableCell align="center" >
                                              <strong>{fuelSummary.kgPerTon[layerIndex].toFixed(2)}</strong>
                                            </TableCell>
                                            <TableCell align="center" >
                                              <strong>{fuelSummary.totalTon[layerIndex].toFixed(2)}</strong>
                                            </TableCell>
                                          </React.Fragment>
                                        ))}
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                  {/* <Button onClick={addChemicalRow} variant="contained" color="secondary" style={{ margin: "10px" }}>
                                        Add Chemical
                                    </Button> */}
                                </TableContainer>
                              </CustomTableContainer>
                            </CardContent>
                          </Card>
                        </>) : (null)}
                      </TabPanel>

                    </SwipeableViews>
                  </>) : (null)}
                </Box>
              </Grid>
            </Grid>
          </Grid>

        </ResponsiveBox>
      </>)}
    </Box>

  );
};

export default AddBillOfMaterialPlan;
